import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject, signal } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { constants, generateRandomString } from '../constants';
import { IdentifyUserResponse, PasswordStatusCheckResponse, ResponseBaseInfo } from '../model/passwordStatusCheckRespoonse';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  private http = inject(HttpClient);
  private cookies = inject(CookieService);
  readonly sessionCookie = signal<string>(this.cookies.get('SESSION_SCTX')).asReadonly();

  identifyUser(username: string) {
    const headers = new HttpHeaders({
      AppId: constants.appId,
      fsreqid: constants.fsreqid + generateRandomString(32, '#1Aa'),
      SESSION_CTX: this.sessionCookie(),
      AppName: constants.appName,
      'Accept-Token-Type': 'ET',
      'Token-Location': 'HEADER',
      'Accept-Token-Location': 'HEADER',
    });
    const data = {
      username: username,
    };

    return this.http.post<IdentifyUserResponse>(constants.baseUrl + '/user/identity/username', data, {
      headers,
      withCredentials: true,
    });
  }


  clearSession() {
    const headers = new HttpHeaders({
      AppId: constants.appId,
      fsreqid: constants.fsreqid + generateRandomString(32, '#1Aa'),
      SESSION_CTX: this.sessionCookie(),
      AppName: constants.appName,
      'Accept-Token-Type': 'ET',
      'Token-Location': 'HEADER',
      'Accept-Token-Location': 'HEADER',
    });

    return this.http.delete<ResponseBaseInfo>(constants.baseUrl + '/user/session/login', {
      headers,
      withCredentials: true,
    });
  }


  checkPasswordStatus() {
    const headers = new HttpHeaders({
      AppId: constants.appId,
      fsreqid: constants.fsreqid + generateRandomString(32, '#1Aa'),
      SESSION_CTX: this.sessionCookie(),
      AppName: constants.appName,
      'Accept-Token-Type': 'ET',
      'Token-Location': 'HEADER',
      'Accept-Token-Location': 'HEADER',
    });

    const data = {
      requestBaseInfo: {},
    };

    return this.http.post<PasswordStatusCheckResponse>(constants.baseUrl + '/user/factor/password/status', data, {
      headers,
      withCredentials: true,
    });
  }

  sessionLogout() {
    const options = {
      headers: new HttpHeaders({
        AppId: constants.appId,
        fsreqid: constants.fsreqid + generateRandomString(32, '#1Aa'),
        SESSION_CTX: this.sessionCookie(),
        AppName: constants.appName,
        'Accept-Token-Type': 'FAC',
        'Token-Location': 'HEADER',
        'Accept-Token-Location': 'HEADER',
        eventtype: 'login',
        sub_eventtype: 'login_analyze',
      }),
      body: {
        requestBaseInfo: {
          sessionTokens: {},
        },
        withCredentials: true,
      },
    };
    return this.http.delete(constants.baseUrl + '/user/session/login/', options);
  }
}
